import BookAMaterial from './bookAMaterial';
import CheckoutMaterialPresenter from './checkoutMaterialPresenter';
import OrderSummary from './components/orderSummary';
import CartModalPresenter from '@src/cart/cartModalPresenter';
import TwoColumnCheckoutBody from '@src/checkout/components/TwoColumnCheckoutBody';
import { useUser } from '@src/services/userContext';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from 'theme-ui';
import { Themed } from '@theme-ui/mdx';

// import DiscountBar from '../components/discountBar';

const checkoutMaterial = () => {
  const { t, i18n } = useTranslation();
  const user = useUser();

  const checkoutMaterialPresenter = new CheckoutMaterialPresenter();
  const cartModalPresenter = new CartModalPresenter();
  const [viewModel, setViewModel] = useState({ summary: {}, info: {} });

  useEffect(() => {
    const updateView = (generatedVm) => {
      setViewModel(generatedVm);
    };

    checkoutMaterialPresenter.load(updateView);

    return updateView;
  }, []);

  return (
    <Box>
      <Box
        className="checkout-header"
        sx={{ padding: '30px', textAlign: 'center' }}
      >
        <Themed.h3 sx={{ margin: 0 }}>{viewModel.title}</Themed.h3>
      </Box>
      <TwoColumnCheckoutBody
        firstColumn={<OrderSummary vm={viewModel.summary} />}
        secondColumn={
          <BookAMaterial
            vm={viewModel.info}
            addToCart={async () => {
              await cartModalPresenter.addItemToCart({
                variantId: viewModel.variantId,
                user,
              });
              await cartModalPresenter.toggleModal();
            }}
            onNext={async () => {
              await cartModalPresenter.addItemToCart({
                variantId: viewModel.variantId,
                user,
              });
              await cartModalPresenter.openCheckout(user);
            }}
          />
        }
      />
      {/* <Box>
        <DiscountBar />
      </Box> */}
    </Box>
  );
};

export default checkoutMaterial;
